import { render } from "./desktop.vue?vue&type=template&id=1ab20ba6&scoped=true"
import script from "./desktop.vue?vue&type=script&lang=js"
export * from "./desktop.vue?vue&type=script&lang=js"

import "./desktop.vue?vue&type=style&index=0&id=1ab20ba6&lang=scss&scoped=true"
import "./desktop.vue?vue&type=style&index=1&id=1ab20ba6&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/t3_d_M4E/0/hellmanh/rb-app-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab20ba6"]])

export default __exports__